import React, { useState, useEffect, useRef } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./SideBar.css";
import LogoNav from "../../assets/communityXlogo.svg";
import userManual from "../../assets/User-Manual_Icon.svg";
import { Image, Row, Col } from "react-bootstrap";
import { MdLogout } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { removeUserCredentials } from "../../Utils/LocalStorage";
import dashboardicon from "../../assets/Dashboard.svg";
import listingicon from "../../assets/Business Listings.svg";
import customerlistingicon from "../../assets/Customer listing.svg";
import marketplaceicon from "../../assets/Marketplace Setup.svg";
import communicationicon from "../../assets/Communications.svg";
import shoplocalAIicon from "../../assets/shoplocal AI.svg";
import couponicon from "../../assets/Coupons.svg";
import vouchericon from "../../assets/Vouchers.svg";
import EmailLink from "../EmailLink/EmailLink";

const SideBar = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [activeStyle, setActiveStyle] = useState("");
  const [navHeight, setNavHeight] = useState("auto");
  const navHeadWrapperRef = useRef(null);

  const LogoutHandler = (e) => {
    e.preventDefault();
    removeUserCredentials();
    navigate("/");
  };

  useEffect(() => {
    setUserName(localStorage.getItem("cityName"));
    const path = window.location.href;
    const endPath = path.split("/");

    if (endPath[3] === "dashboard") {
      setActiveStyle("dashboard");
    }
    if (endPath[3] === "business-listings") {
      setActiveStyle("business-listings");
    }
    if (endPath[3] === "vouchers") {
      setActiveStyle("vouchers");
    }
    if (endPath[3] === "coupons") {
      setActiveStyle("coupons");
    }
    if(endPath[3] === "messages"){
      setActiveStyle("messages")
    }
    if (endPath[3] === "communications") {
      setActiveStyle("communications");
    }
    if (endPath[3] === "marketplace-setup") {
      setActiveStyle("marketplace-setup");
    }
    if (endPath[3] === "shop-local-ai") {
      setActiveStyle("shop-local-ai");
    }

    setTimeout(() => {
      const updateNavHeight = () => {
        if (navHeadWrapperRef.current) {
          const navHeadHeight = navHeadWrapperRef.current.offsetHeight;
          setNavHeight(`calc(100% - ${navHeadHeight}px)`);
        }
      };

      updateNavHeight();
      window.addEventListener("resize", updateNavHeight);

      return () => window.removeEventListener("resize", updateNavHeight);
    }, 500);
  }, []);

  const splitUsername = (str) => {
    let result = [];

    if (/^[A-Z]+$/.test(str)) {
      for (let i = 0; i < str.length; i += 16) {
        let segment = str.slice(i, i + 16);
        if (segment.length === 16 && i + 16 < str.length) {
          segment += "-";
        }
        result.push(segment);
      }
    } else {
      result.push(str);
    }

    return result;
  };

  const profileHandler = () => {
    navigate("/marketplace-setup/profile");
  };

  const formattedUsernames = splitUsername(userName);

  return (
    <Navbar expand="lg" className="custom-nav-main">
      <div className="nav-head-wrapper" ref={navHeadWrapperRef}>
        <div className="d-flex">
          <Image src={LogoNav} className="mx-3" style={{width:180}} />
        </div>
        <div className="my-3 d-flex mx-3 mobile-profile">
          <div
            to="/my-profile"
            className="hide-mobile hide-tab"
            onClick={profileHandler}
          >
            {formattedUsernames.map((segment, index) => (
              <div key={index} className="username" style={{ fontSize: 18 }}>
                <p className="hyphenated">{index > 0 && "-"}</p>
                <p className="hyphenated">{segment}</p>
              </div>
            ))}
            {/* <p className="username">{userName}</p> */}
          </div>
        </div>
      </div>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse
        style={{ height: navHeight }}
        id="basic-navbar-nav"
        className="custom-nav mt-1"
      >
        <Nav className="me-auto">
          <div className="nav-wrapper">
            <Link
              to="/dashboard"
              className={
                activeStyle === "dashboard"
                  ? "nav-link linkActive"
                  : "nav-link mt-0"
              }
            >
              <img src={dashboardicon} className="nav-icon dash" />
              Dashboard
            </Link>
            {/* 2 */}
            <Link
              to="/business-listings/all-listings"
              className={
                activeStyle === "business-listings"
                  ? "nav-link linkActive"
                  : "nav-link mt-0"
              }
            >
              <img src={listingicon} className="nav-icon" />
              Business Listings
            </Link>
            {/* 3 */}
            <Link
              to="/customer-list"
              className={
                activeStyle === "customer-listings"
                  ? "nav-link linkActive"
                  : "nav-link mt-0"
              }
            >
              <img src={customerlistingicon} className="nav-icon" />
             Customer List
            </Link>
            {/* 4 */}
            <Link
              to="/events-list/all-events"
              className={
                activeStyle === "customer-listings"
                  ? "nav-link linkActive"
                  : "nav-link mt-0"
              }
            >
              <img src={customerlistingicon} className="nav-icon" />
             Events List
            </Link>
            {/* 5 */}
            <Link
              to="/vouchers/vouchers-dashboard"
              className={
                activeStyle === "vouchers"
                  ? "nav-link linkActive"
                  : "nav-link mt-0"
              }
            >
              <img src={vouchericon} className="nav-icon" />
              Vouchers
            </Link>
            {/* 4 */}
            <Link
              to="/coupons/coupons-dashboard"
              className={
                activeStyle === "coupons"
                  ? "nav-link linkActive"
                  : "nav-link mt-0"
              }
            >
              <img src={couponicon} className="nav-icon" />
              Coupons
            </Link>
            {/* 5 */}
            <Link
              to="/messages/coupon"
              className={
                activeStyle === "messages"
                  ? "nav-link linkActive"
                  : "nav-link mt-0"
              }
            >
              <img src={communicationicon} className="nav-icon" />
              Messages
            </Link>
            <Link
              to="/communications/manage-templates"
              className={
                activeStyle === "communications"
                  ? "nav-link linkActive"
                  : "nav-link mt-0"
              }
            >
              <img src={communicationicon} className="nav-icon" />
              Communications
            </Link>
            <Link
              to="/marketplace-setup/home-page-setup"
              className={
                activeStyle === "marketplace-setup"
                  ? "nav-link linkActive"
                  : "nav-link mt-0"
              }
            >
              <img src={marketplaceicon} className="nav-icon" />
              Marketplace Setup
            </Link>
            <Link
              to="/shop-local-ai/email-for-invite-business"
              className={
                activeStyle === "shop-local-ai"
                  ? "nav-link linkActive"
                  : "nav-link mt-0"
              }
            >
              <img src={shoplocalAIicon} className="nav-icon" />
              CommunityX AI
            </Link>
          </div>
          <div className="nav-button-wrapper">
            <a
              className="nav-button user-manual"
              target="_blank"
              href={`${process.env.REACT_APP_ENDUSER_DOMAIN}support`}
            >
              <img src={userManual} className="nav-icon" /> User Manual
            </a>
            <EmailLink
              className="nav-button email-link"
              email="support@communityx.digital"
              subject=""
              body=""
            />
            <Link className="nav-button" onClick={LogoutHandler}>
              <MdLogout className="nav-icon" /> Logout
            </Link>
          </div>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default SideBar;
